<template>
  <div class="cb-spinner" :class="size === 'small' ? 'cb-spinner--small' : ''">
    <div class="cb-spinner__mask">
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="40" />
      </svg>
    </div>
    <img alt="Loading" class="cb-spinner__img" src="../../assets/icons/loading-icon.svg" />
  </div>
</template>

<script>
export default {
  props: ['size'],
};
</script>

<style lang='scss' scoped>
@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes delayed-rotate {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotate(45deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes stroke-dashoffset {
  0% {
    stroke-dashoffset: 215;
  }

  50% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: 215;
  }
}

.cb-spinner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;

  &__mask {
    height: 64px;
    width: 64px;
    position: relative;
    z-index: 2;
    animation: 3s linear infinite rotate;

    svg {
      animation: 3.5s ease-in-out infinite both delayed-rotate;

      circle {
        animation: 3.5s ease-in-out infinite both stroke-dashoffset;
        display: block;
        fill: transparent;
        stroke: $azure;
        stroke-dasharray: 215;
        stroke-dashoffset: 215;
        stroke-width: 18px;
        transform-origin: 50% 50%;
      }
    }
  }

  &__img {
    height: 54px;
    width: 54px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &--small {
    height: 26px;
    width: 26px;

    .cb-spinner__mask {
      height: 22px;
      width: 22px;
    }

    .cb-spinner__img {
      height: 18px;
      width: 18px;
    }
  }

  @include desktop {
    height: 96px;
    width: 96px;

    &__mask {
      height: 94px;
      width: 94px;
    }

    &__img {
      height: 82px;
      width: 82px;
    }

    &--small {
      height: 26px;
      width: 26px;

      .cb-spinner__mask {
        height: 22px;
        width: 22px;
      }

      .cb-spinner__img {
        height: 18px;
        width: 18px;
      }
    }
  }
}
</style>
